import { DEFAULT_LOCATION, fetchLocation } from "libs/utils/location";
import { useState, useEffect } from "react";
import * as Location from "expo-location";
import { reportLog } from "../utils/logs";

const useLocation = () => {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { status: checkStatus } =
          await Location.getForegroundPermissionsAsync();
        if (checkStatus === "denied") {
          setLocation({
            coords: {
              latitude: parseFloat(DEFAULT_LOCATION.location.latitude),
              longitude: parseFloat(DEFAULT_LOCATION.location.longitude),
            },
          });
        } else {
          setLoading(true);
          const loc = await fetchLocation();
          setLocation(loc);
        }
      } catch (error) {
        reportLog({
          error: error,
          location: "userLocation[15,25]",
          body: {},
        });
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { location, loading, error };
};

export default useLocation;
